__turbopack_context__.v({
  "entry": "CKPyVW_entry",
  "is-collapsed": "CKPyVW_is-collapsed",
  "is-expanded": "CKPyVW_is-expanded",
  "plus-icon": "CKPyVW_plus-icon",
});
